import { STAGE_STATUS } from '../constants/stages';
import { RT } from '../theme/retentionTheme';
import { SoftChip } from './ui';

const LOOK = {
  0: { color: RT.faint, icon: 'solar:clock-circle-linear' },
  1: { color: RT.warning, icon: 'solar:play-circle-bold' },
  2: { color: RT.success, icon: 'solar:check-circle-bold' },
  3: { color: RT.muted, icon: 'solar:skip-next-bold' },
  4: { color: RT.error, icon: 'solar:restart-circle-bold' },
};

export default function StageStatusChip({ status = 0 }) {
  const key = STAGE_STATUS[Number(status)] ? Number(status) : 0;
  return <SoftChip label={STAGE_STATUS[key].label} color={LOOK[key].color} icon={LOOK[key].icon} />;
}
